const featuredlistingsdata = [
  {
    id: 2,
    businessname: 'VisionRsoft',
    title: 'VisionRsoft',
    businesstype: 'Information Technology Services',
    locationname: 'Mangalore',
    areaname: '',
    address1: 'VisionRsoft',
    aboutdescription: 'Software consulting for your businesses.',
    contactperson: 'Oswald R',
    contactnumber: '',
    imagepath: '/images/homerotated/itconsultancy_visionrsoft_home1.jpg',
    website: 'http://www.visionrsoft.com',
    photos: [
      '/images/homerotated/itconsultancy_visionrsoft_s1.jpg',
      '/images/homerotated/itconsultancy_visionrsoft_s2.jpg',
      '/images/homerotated/itconsultancy_visionrsoft_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 1,
    dateposted: '2024-05-10T10:00:00Z',
    sm_insta: 'https://instagram.com/visionrsoftware',
    sm_facebook: 'https://facebook.com/visionrsoftware',
    sm_whatsapp: '',
    sm_youtube: 'https://youtube.com/visionrsoftware',
    accountstatus: 'Active',
  },
  {
    id: 3,
    businessname: 'Victory Fibers',
    title: 'Victory Fibers',
    businesstype: 'Fiber Door Manufacturers',
    locationname: 'Kundapura',
    areaname: 'Church Road',
    address1: 'Victory Fibers, Near Mangalore Tile Works, Church Road, Kundapura',
    aboutdescription: 'High-quality fiber doors for residential and commercial use. Durable and stylish designs.',
    contactperson: 'Loy Carvalho',
    contactnumber: '919343090441',
    imagepath: '/images/homerotated/gs_fibre_loy_victoryfibres_home1.jpg',
    website: '',
    photos: [
      '/images/homerotated/gs_fibre_loy_victoryfibres_s1.jpg',
      '/images/homerotated/gs_fibre_loy_victoryfibres_s2.jpg',
      '/images/homerotated/gs_fibre_loy_victoryfibres_s3.jpg',
      '/images/homerotated/gs_fibre_loy_victoryfibres_s4.jpg',
    ],
    featuredListings: true,
    listingorder: 3,
    dateposted: 'Feb 23, 2026, 9:00 AM',
    sm_insta: 'https://instagram.com/victoryfibers',
    sm_facebook: 'https://facebook.com/victoryfibers',
    sm_whatsapp: 'https://wa.me/9198#####789',
    sm_youtube: 'https://youtube.com/victoryfibers',
    accountstatus: 'Active',
  },
  {
    id: 4,
    businessname: 'Weldone Decorators',
    title: 'Weldone Decorators',
    businesstype: 'Decorators',
    locationname: 'Mangalore',
    areaname: 'Jeppu-Majila',
    address1: 'Weldone Decorators, Jeppu-Majila, Mangalore',
    aboutdescription: 'Home and event decoration specialists.',
    contactperson: 'Melvin Fernandes',
    contactnumber: '919845333031',
    imagepath: '/images/homerotated/ep_decor_melvinfern_home1.jpg',
    photos: [
      '/images/homerotated/ep_decor_melvinfern_s1.jpg',
      '/images/homerotated/ep_decor_melvinfern_s2.png',
      '/images/homerotated/ep_decor_melvinfern_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 5,
    dateposted: 'Feb 23, 2026, 9:00 AM',
    sm_insta: 'https://instagram.com/weldonedecorators',
    sm_facebook: 'https://facebook.com/weldonedecorators',
    sm_whatsapp: 'https://wa.me/9198#####789',
    sm_youtube: 'https://youtube.com/weldonedecorators',
    accountstatus: 'Active',
  },
  {
    id: 5,
    businessname: 'Pinto Enclave',
    title: 'Pinto Enclave',
    businesstype: 'Venue Hall',
    locationname: 'Mangalore',
    areaname: 'Bondel - Pachanady',
    address1: 'Pinto Enclave, Bondel - Pachanady, Mangalore',
    aboutdescription: 'Spacious venue hall for weddings and events.',
    contactperson: 'Vinod Pinto',
    contactnumber: '919972451810',
    imagepath: '/images/eventplanningimages/ep_venue_vinod_pintoenclave_home1.jpg',
    website: 'http://www.pintosenclave.com',
    photos: [
      '/images/homerotated/ep_venue_vinod_pintoenclave_s1.jpg',
      '/images/homerotated/ep_venue_vinod_pintoenclave_s2.jpg',
      '/images/homerotated/ep_venue_vinod_pintoenclave_s4.jpg',
    ],
    featuredListings: true,
    listingorder: 6,
    dateposted: 'Feb 23, 2026, 9:00 AM',
    sm_insta: 'https://instagram.com/pintoenclave',
    sm_facebook: 'https://facebook.com/pintoenclave',
    sm_whatsapp: 'https://wa.me/9198#####789',
    sm_youtube: 'https://youtube.com/pintoenclave',
    accountstatus: 'Active',
  },
  {
    id: 6,
    businessname: 'Bharath Transport',
    title: 'Bharath Transport',
    businesstype: 'transport',
    locationname: 'Kundapura',
    areaname: 'Kunnapura Town',
    address1: 'Bharath Transport, Kunnapura Town, Kundapura',
    aboutdescription: 'Reliable and efficient transport services for all your needs.',
    contactperson: 'Dinesh Bhandari',
    contactnumber: '917975715868',
    imagepath: '/images/homerotated/gs_transport_dineshb_bharathtransport_home1.jpg',
    website: '0',
    photos: [
      '/images/homerotated/gs_transport_dineshb_bharathtransport_s1.jpg',
      '/images/homerotated/gs_transport_dineshb_bharathtransport_home1.jpg',
      '/images/homerotated/gs_transport_dineshb_bharathtransport_s3.jpg',
    ],
    featuredListings: true,
    listingorder: 9,
    dateposted: 'Feb 19, 2026, 10:00 AM',
    sm_insta: 'https://instagram.com/bharathtransportdinesh',
    sm_facebook: '',
    sm_whatsapp: 'https://wa.me/917975715868',
    sm_youtube: '',
    accountstatus: 'Active',
  },
  
];

export default featuredlistingsdata;
